import { colors } from "shared/theme/color";
import { Lang, currentLang, setLang } from "i18n";
import { translate } from "shared/languages";
import { textPx } from "shared/constants/zoom";

/**
 * EN | ID pill segmented control, ported from spott-client/spott-instructor
 * into the platform's inline-style idiom. Lives on the login hero and the
 * Pengaturan preferences card. No self-subscription to language changes:
 * LanguageRoot remounts the whole tree on setLang, which repaints this too.
 * Hover states are color-only.
 */
const LangToggle = () => {
  const lang = currentLang();
  return (
    <div
      role="tablist"
      aria-label={translate("preferences.language")}
      style={{
        display: "inline-flex",
        padding: 4,
        borderRadius: 9999,
        border: `1px solid ${colors.line}`,
        background: colors.bgSoft,
      }}
    >
      {(["en", "id"] as Lang[]).map((l) => {
        const active = l === lang;
        return (
          <button
            key={l}
            role="tab"
            aria-selected={active}
            onClick={() => {
              if (!active) setLang(l);
            }}
            style={{
              border: "none",
              cursor: "pointer",
              borderRadius: 9999,
              padding: "6px 14px",
              fontFamily: "var(--font-body)",
              fontSize: textPx(12),
              fontWeight: 600,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              background: active ? colors.card : "transparent",
              color: active ? colors.ink : colors.ink3,
              boxShadow: active ? "0 1px 2px rgba(15, 15, 14, 0.06)" : "none",
              transition: "background 0.15s ease, color 0.15s ease",
            }}
          >
            {l}
          </button>
        );
      })}
    </div>
  );
};

export default LangToggle;
